import { FILTER_ROOT_SELECTOR } from "./constants";
import { replaceNode } from "./dom";
import { resetLoadMorePageState } from "./loadMore";

export const replaceSentinel = (gridSection: HTMLElement, remoteRoot: ParentNode, gridContainer?: HTMLElement | null) => {
  const grid = gridContainer ?? gridSection.querySelector("#products-grid");
  const newSentinel = remoteRoot.querySelector("#load-more-sentinel");
  const oldSentinel = gridSection.querySelector("#load-more-sentinel");

  if (newSentinel) {
    const imported = document.importNode(newSentinel, true);
    if (oldSentinel) oldSentinel.replaceWith(imported);
    else if (grid) grid.insertAdjacentElement("afterend", imported);
  } else if (oldSentinel) {
    oldSentinel.remove();
  }
};

export const patchGridSection = (gridSection: HTMLElement, remoteRoot: ParentNode) => {
  const currentGrid = gridSection.querySelector<HTMLElement>("#products-grid");
  const remoteGrid = remoteRoot.querySelector<HTMLElement>("#products-grid");

  if (currentGrid && remoteGrid) {
    currentGrid.innerHTML = remoteGrid.innerHTML;
    currentGrid.className = remoteGrid.className;
    currentGrid.style.opacity = "1";
    currentGrid.removeAttribute("aria-busy");
    delete currentGrid.dataset.skeleton;
    resetLoadMorePageState(gridSection);
  }

  replaceSentinel(gridSection, remoteRoot, currentGrid);

  const currentFilters = gridSection.querySelector<HTMLElement>(FILTER_ROOT_SELECTOR);
  const remoteFilters = remoteRoot.querySelector<HTMLElement>(FILTER_ROOT_SELECTOR);
  if (currentFilters && remoteFilters) {
    currentFilters.innerHTML = remoteFilters.innerHTML;
  }

  replaceNode(gridSection.querySelector("#informationen"), remoteRoot.querySelector("#informationen"));

  return Boolean(currentGrid && remoteGrid);
};

export const patchGridFromHtml = (gridSection: HTMLElement, gridHtml: string) => {
  const temp = document.createElement("div");
  temp.innerHTML = gridHtml;
  const remote = temp.querySelector<HTMLElement>(".js-collection-section") ?? temp;
  return patchGridSection(gridSection, remote);
};

export const showGridLoadingState = (gridContainer: HTMLElement, loading: HTMLElement | null) => {
  loading?.classList.remove("hidden");
  gridContainer.style.opacity = "0.5";
  gridContainer.setAttribute("aria-busy", "true");
};

export const hideGridLoadingState = (gridContainer: HTMLElement, loading: HTMLElement | null) => {
  loading?.classList.add("hidden");
  gridContainer.style.opacity = "1";
  gridContainer.removeAttribute("aria-busy");
};
